<template>
  <Page :response="response">
    <SettingsForm :company="resource"
                  :voucher-templates="voucherTemplates"
                  @formSubmit="formSubmitted($event)" />
  </Page>
</template>

<script>
import store from "../Company/CompanyStore";
import VoucherTemplateStore from "@fawter/components/VoucherTemplates/VoucherTemplateStore";

import SettingsForm from "./SettingsForm.vue";
import SettingsMixin from "./SettingsMixin";

const responseStore = {
  response: null,
  voucherTemplates: {}
};

const fetchResource = async (to, from, next) => {
  responseStore.response = await store.fetch(to.params.companyId);
  responseStore.voucherTemplates = await VoucherTemplateStore.fetchAll(
    { companyId: to.params.companyId });

  next();
};

export default {
  name: "SettingsEdit",

  title () {
    return this.$t("common.settings") + ` - ${store.currentCompany.name} - ${Dashboard.currentTenant.name}`;
  },

  components: {
    SettingsForm
  },

  mixins: [SettingsMixin],

  beforeRouteEnter: fetchResource,
  beforeRouteUpdate: fetchResource,

  data () {
    return {
      responseStore: responseStore,
      store: store
    };
  },

  computed: {
    voucherTemplates () {
      return this.$_.groupBy(this.responseStore.voucherTemplates.collection,
        "voucher_type");
    }
  },

  methods: {
    async formSubmitted (e) {
      this.handleResponseInplace(await store.update(this.resource.id));
    }
  }
};
</script>
